function TrimObjectStrings(obj) {
    if (typeof obj !== 'object' || obj === null) {
        return obj;
    }

    if (Array.isArray(obj)) {
        return obj.map(item => TrimObjectStrings(item));
    }

    const trimmedObj = {};
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            const value = obj[key];
            if (typeof value === 'string') {
                const trimmedValue = value.trim();
                trimmedObj[key] = trimmedValue === "" ? null : trimmedValue;
            } else if (typeof value === 'object') {
                trimmedObj[key] = TrimObjectStrings(value);
            } else {
                trimmedObj[key] = value;
            }
        }
    }

    return trimmedObj;
}

export default TrimObjectStrings;